export default {
  title: 'iCabbi Firebase Management Console',
  login: {
    label: 'Login with Google',
    logout: 'Logout'
  },
  build: {
    feedback: {
      title: 'Build Feedback',
      hasError: 'Your build has been completed with errors!',
      success: 'Your build has been completed successfully!',
      ok: 'ok'
    }
  },
  form: {
    submit: 'Submit',
    timeZone: 'Time Zone',
    regionCode: 'Region Code',
    locationId: 'Location Id',
    project: {
      label: 'Firebase Project'
    },
    androidApp: {
      label: 'Android App',
      packageName: 'Package Name',
      sha: 'Sha-1',
    },
    iosApp: {
      label: 'iOS App',
      bundleId: 'Bundle Id',
    }
  },
  routes: {
    gcpProjects: 'Gcp Projects',
    firebaseProjects: 'Firebase Projects',
  },
  projects: {
    label: "Create Firebase Projects",
    create: "Create Firebase Project",
    displayName: 'Name',
    actions: 'Actions',
    types: {
      label: 'Project Type',
      gcp: 'GCP Project',
      firebase: 'Firebase Project'
    },
  }
};
